<template>
    <b-modal id="modal-send-app" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
        :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('sendApp.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col sm="12">
                    <b-form-group :label="$t('sendApp.driverNameLabel')" class="text-left mb-3">
                        <b-form-input v-model="recordPayload.driver_name" disabled :placeholder="$t('sendApp.driverNamePlaceholder')"
                            class="unit f-12" required></b-form-input>
                        <p v-if="errors && errors.driver_name" class="field-error mb-lg-3">
                            {{ errors.driver_name[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group :label="$t('sendApp.jobNameLabel')" class="text-left mb-3">
                        <b-form-input v-model="recordPayload.job_name" disabled :placeholder="$t('sendApp.jobNamePlaceholder')"
                            class="unit f-12" required></b-form-input>
                        <p v-if="errors && errors.job_name" class="field-error mb-lg-3">
                            {{ errors.job_name[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group :label="$t('sendApp.addCcLabel')" class="text-left mb-3">
                        <b-form-input v-model="recordPayload.add_cc" :placeholder="$t('sendApp.addCcPlaceholder')" class="unit f-12"
                            required></b-form-input>
                        <p v-if="errors && errors.add_cc" class="field-error mb-lg-3">
                            {{ errors.add_cc[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group :label="$t('sendApp.appUrlLabel')" label-for="check-user" class="text-left label position-relative">
                        <b-form-textarea rows="3" disabled style="padding-right: 10%;" class="resize-none f-12"
                            v-model="recordPayload.link"></b-form-textarea>
                        <svg @click="copyURL(recordPayload.link)" class="copy-referrral-link cursor-pointer" width="15" height="15"
                            viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer="">
            <div class="text-right modal-footer border-0 p-0 mt-3 mx-0">
                <b-button class="mx-0 h-40px w-100px mr-3 m-0" block @click="resetFilterFields">{{ $t('sendApp.close') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendInvite">{{ $t('sendApp.send') }}</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { mapActions } from "vuex";
import { checkEmail } from "@/services/helper";
export default {
    name: "SendApp",
    props:['data'],
    data() {
        return {
            jobOptions: [],
            nameOptions: [],
            checkEmail,
            errors: {},
            recordPayload: {
                driver_name: '',
                job: '',
                add_cc: '',
                link: ''
            },
        }
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.recordPayload.driver_name = newVal.first_name + " " + newVal.last_name || '';
                    this.recordPayload.job_name = newVal.application.job_name || '';
                    this.recordPayload.link = `${newVal.application.job_link}/${newVal.application.id}` || '';
                }
            }
        }
    },
    methods: {
        ...mapActions(['getRecruitingData', 'getFilteredDrivers', 'setNotification', 'sendJobApplicationInvite', 'setLoader']),
        async searchJobs(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            const data = await this.getRecruitingData({ type: "job", url });
            data.data.map((job) => {
                options.push({
                    id: `${job.id}`,
                    label: job.name,
                });
            });
            this.jobOptions = options
            this.jobOptions = [...new Map(this.jobOptions.map(item => [item['id'], item])).values()]
        },
        async searchDrivers(searchText) {
            let options = []
            const driverRecords = await this.getFilteredDrivers(searchText);
            driverRecords.map((driver) => {
                options.push({
                    id: `${driver.id}`,
                    label: driver.name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        async copyURL(url) {
            if (url) {
                try {
                    await navigator.clipboard.writeText(url);
                    await this.setNotification({
                        msg: this.$t('sendApp.appLinkCopied'),
                        type: "success",
                        color: "green",
                    });
                } catch (e) {
                    console.log(e)
                }
            }
        },
        resetFilterFields() {
            this.recordPayload.add_cc = '';
            this.errors = {};
            this.$bvModal.hide('modal-send-app');
        },
        async sendInvite(){
            try {
                this.setLoader(true);
                if (this.recordPayload.add_cc) {
                    if (!this.checkEmail(this.recordPayload.add_cc)) {
                        throw {
                            phone: [this.$t('sendApp.wrongFormat')],
                        };
                    }
                }
                await this.sendJobApplicationInvite({candidate_id: this.data.id, cc_email: this.recordPayload.add_cc});
                await this.setNotification({
                    msg: this.$t('sendApp.inviteSent'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false);
                this.resetFilterFields();
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    }
}
</script>